import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setErr(res.error || "Login fehlgeschlagen");
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-cream flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-10">
          <img
            src="https://customer-assets.emergentagent.com/job_dress-rental-8/artifacts/addnkbh0_01282ab7-d3ab-4bd8-a457-edb52e8d5072.jpeg"
            alt="10/10 Kleiderverleih"
            className="h-14 w-auto object-contain mx-auto mb-2"
          />
          <span className="overline">10/10 Kleiderverleih</span>
        </Link>
        <div className="bg-white border border-[#E5E0D8] p-10">
          <div className="overline mb-3">Boutique Admin</div>
          <h1 className="font-display text-4xl mb-8">Login</h1>

          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="overline block mb-1">E-Mail</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none"
                required
              />
            </div>
            <div>
              <label className="overline block mb-1">Passwort</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none"
                required
              />
            </div>
            {err && <div data-testid="login-error" className="text-sm text-red-600">{err}</div>}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={submitting}
              className="w-full bg-ink text-cream py-4 text-xs tracking-widest uppercase hover:bg-gold transition-colors disabled:opacity-50"
            >
              {submitting ? "Anmelden..." : "Anmelden"}
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 text-sm text-ink/60 link-underline">← Zur Website</Link>
      </div>
    </div>
  );
}
